// TODO заменить все строчные вхождения на данный справочник
export const LANGUAGE = {
  RU: 'ru',
  EN: 'en'
} as const;

export type LanguageTypes = typeof LANGUAGE[keyof typeof LANGUAGE];
